export default "__VITE_ASSET__Cqa2_nlx__"